import React, { useState } from 'react';
import CreditApplicationSection from './CreditApplicationSection';
import FirstSection from './FirstSection';
import ExhibitSection from './ExhibitSection';
import './LoaDocuments.css';
import SecondSection from './SecondSection';
import ThirdSection from './ThirdSection';
import LoaSection from './LoaSection';
import PaymentAuthorizationSection from './PaymentAuthorizationSection';

const LoaDocuments = ({
  proposalData,
  companyField,
  selectLocations,
  getBoxSumAmount,
  getLocationSum,
  getInstallationSum,
  getLocationSumAmount,
  getLocationOTCAmount,
  getLocationInstAmount,
}) => {
  const [showTollFreeNumber, setShowTollFreeNumber] = useState(false);

  return (
    <div className="loa-doc-wrapper">
      <ExhibitSection
        getLocationSumAmount={getLocationSumAmount}
        getLocationOTCAmount={getLocationOTCAmount}
        getLocationInstAmount={getLocationInstAmount}
        getBoxSumAmount={getBoxSumAmount}
        getLocationSum={getLocationSum}
        getInstallationSum={getInstallationSum}
        proposalData={proposalData}
        tollFreeNumberExist={setShowTollFreeNumber}
        showTollFreeNumber={showTollFreeNumber}
        date={proposalData ? proposalData.created : undefined}
        billingAddress={proposalData ? proposalData.billingAddress : undefined}
        locations={selectLocations || undefined}
        companyField={companyField}
      />
      <LoaSection
        getLocationSumAmount={getLocationSumAmount}
        getBoxSumAmount={getBoxSumAmount}
        proposalData={proposalData}
        date={proposalData ? proposalData.created : undefined}
        billingAddress={proposalData ? proposalData.billingAddress : undefined}
        locations={selectLocations ? selectLocations : undefined}
        companyField={companyField}
      />
      <FirstSection
        getLocationSumAmount={getLocationSumAmount}
        getBoxSumAmount={getBoxSumAmount}
        proposalData={proposalData}
        date={proposalData ? proposalData.created : undefined}
        billingAddress={proposalData ? proposalData.billingAddress : undefined}
        locations={selectLocations ? selectLocations : undefined}
        companyField={companyField}
      />
      <SecondSection
        date={proposalData ? proposalData.created : undefined}
        billingAddress={proposalData ? proposalData.billingAddress : undefined}
        locations={selectLocations || undefined}
        companyField={companyField}
        showTollFreeNumber={showTollFreeNumber}
      />
      <ThirdSection
        co={proposalData ? proposalData.careOf : ''}
        phone={proposalData ? proposalData.phone : ''}
        date={proposalData ? proposalData.created : undefined}
        billingAddress={proposalData ? proposalData.billingAddress : undefined}
        companyField={companyField}
      />
      <CreditApplicationSection
        billingAddress={proposalData ? proposalData.billingAddress : undefined}
        fax={proposalData ? proposalData.fax : undefined}
        companyField={companyField}
        proposalData={proposalData ? proposalData.logo : undefined}
      />
      <PaymentAuthorizationSection />
    </div>
  );
};

export default LoaDocuments;
